import React from "react"
import FormFinancierBucket from "./Form"

export default function CreateFinancierBucket() {
  return <FormFinancierBucket />
}



// WEBPACK FOOTER //
// ./src/components/Financiers/Buckets/Create.js